import { RecommendOptionValueModel } from '../utils/types';

export interface OthersSizeOptionListProps {
  items: Array<RecommendOptionValueModel>;
  renderItem: (item: RecommendOptionValueModel, index: number) => React.ReactNode;
}

export function OthersSizeOptionList({ items, renderItem }: OthersSizeOptionListProps) {
  return <>{items.map(renderItem)}</>;
}
